<template>
  <v-container>
    <v-tabs background-color="secondary" show-arrows dark v-model="tab">
      <v-tab>Dados Pessoais</v-tab>
      <v-tab>Endereço</v-tab>
      <v-tab>Contato</v-tab>
      <v-tab v-show="possuiAnaliseRenda">Composição do Grupo Familiar</v-tab>
      <v-tab>Documentos</v-tab>
      <v-tab @click="atualizarPendenciasInscricao"
        ><v-progress-circular
          v-if="carregandoPendencias"
          indeterminate
          color="white"
        ></v-progress-circular>
        Finalizar</v-tab
      >
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <form-dados-pessoais
          @salvou="salvouDadosPessoais"
        ></form-dados-pessoais>
      </v-tab-item>
      <v-tab-item>
        <form-endereco
          @salvou="salvouEndereco"
          @voltar="voltarAba"
        ></form-endereco>
      </v-tab-item>
      <v-tab-item>
        <form-contato @salvou="salvouContato" @voltar="voltarAba"></form-contato>
      </v-tab-item>
      <v-tab-item v-show="possuiAnaliseRenda">
        <form-renda-pdf></form-renda-pdf>
        <v-toolbar>
          <v-btn color="orange lighten-3" @click="voltarAba">Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mr-4" @click="salvouRenda">Avançar</v-btn>
        </v-toolbar>
      </v-tab-item>
      <v-tab-item>
        <upload-documento
          v-for="item in preMatricula.documentos"
          :key="item.id"
          :documento="item"
          @alterouDocumento="alterouDocumento"
        ></upload-documento>
        <v-toolbar>
          <v-btn color="orange lighten-3" @click="voltarAba">Voltar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" class="mr-4" @click="tab = 5">Avançar</v-btn>
        </v-toolbar>
      </v-tab-item>
      <v-tab-item>
        <form-finalizar
          :carregando="carregandoPendencias"
          :validacoes="pendenciasInscricao"
          @voltar="voltarAba"
        ></form-finalizar>
      </v-tab-item>
    </v-tabs-items>
    <!-- <v-footer color="primary" dark app>
      "Atenção! Se você tem dúvidas sobre os documentos que devem ser apresentados, por favor entre em contato com a equipe de matrícula através dos e-mails abaixo antes de enviar seus documentos:
    </v-footer> -->
  </v-container>
</template>
<script>
import PreMatricula from "@/models/prematricula";
import * as PreMatriculaService from "@/services/prematricula.service";
import UploadDocumento from "@/components/UploadDocumento";
import FormDadosPessoais from "@/components/FormDadosPessoais";
import FormEndereco from "@/components/FormEndereco";
import FormContato from "@/components/FormContato";
import FormDocRendaPDF from "@/components/FormDocRendaPDF";
import FormFinalizar from "@/components/FormFinalizar.vue";

export default {
  name: "home",
  components: {
    "upload-documento": UploadDocumento,
    "form-dados-pessoais": FormDadosPessoais,
    "form-endereco": FormEndereco,
    "form-contato": FormContato,
    "form-renda-pdf": FormDocRendaPDF,
    "form-finalizar": FormFinalizar,
  },
  data() {
    return {
      tab: 0,
      preMatricula: new PreMatricula(),
      pendenciasInscricao: [],
      carregandoPendencias: false,
      endpointUpload:
        process.env.VUE_APP_API_BASEURL + "prematricula/documentos",
    };
  },
  mounted() {
    this.loadPreMatricula();
  },
  methods: {
    loadPreMatricula() {
      this.$nprogress.start();
      PreMatriculaService.getOne()
        .then((pm) => {
          this.preMatricula = pm;
          this.pendenciasInscricao = this.preMatricula.pendenciasInscricao;
          if (this.preMatricula.status.codigo != "RASCUNHO") {
            this.$router.push({ name: "acompanhamento" });
          }
        })
        .finally(() => this.$nprogress.done());
    },
    salvouEndereco() {
      this.tab++ ;
      this.atualizarPendenciasInscricao();
    },
    salvouContato() {
      this.tab++;
      if (!this.possuiAnaliseRenda)
        this.tab++
      this.atualizarPendenciasInscricao();
    },
    salvouRenda() {
      this.tab++;
      this.atualizarPendenciasInscricao();
    },
    salvouDadosPessoais() {
      this.tab++;
      this.atualizarPendenciasInscricao();
    },
    atualizarPendenciasInscricao() {
      this.carregandoPendencias = true;
      PreMatriculaService.getPendenciasInscricao()
        .then((res) => {
          this.pendenciasInscricao = res.data;
        })
        .finally(() => (this.carregandoPendencias = false));
    },
    alterouDocumento() {
      this.atualizarPendenciasInscricao();
    },
    voltarAba(){
      if (!this.possuiAnaliseRenda && this.tab == 4)
        this.tab = 2
      else
        this.tab --;
    }
  },
  computed: {
    possuiAnaliseRenda() {
      if (this.preMatricula.chamadaUtilizaCadunico === false) {
        return this.preMatricula.analises.some(
          (analise) => analise.descricao == "Renda",
        );
      } else {
        return false;
      }
    },
  },
};
</script>
